import {
  SortableColumnKeys,
  SortOrder
} from "@/components/InvoicePay/InvoiceList";

export interface PaymentInfo {
  confirmationNum: string;
  invoiceNums: string[];
  paymentDate?: string;
  paymentMethod: string;
  amount: string;
}

export enum InvoiceFields {
  ConfirmationNum = "Payment ID",
  InvoiceNums = "Invoice #",
  PaymentDate = "Payment date",
  PaymentMethod = "Payment method",
  Amount = "Amount"
}

export enum InvoiceStatus {
  Paid = "paid",
  Open = "open",
  Overdue = "overdue",
  DueSoon = "due_soon",
  Pending = "pending"
}

export enum PaymentStatus {
  Paid = "Paid",
  Open = "Open",
  Overdue = "Overdue",
  DueSoon = "Due Soon",
  Pending = "Pending"
}

export enum DiscountType {
  PromptPay = "PROMPT_PAY",
  Online = "ONLINE"
}

export interface InvoicePriceSummary {
  totalPrice?: number;
  amountDue: number;
  onlineDiscount?: number;
  subtotal: number;
  tax?: number;
  netInvoice: number;
  promptPayDiscount: number;
  promptPayDiscountedTotal: number;
}

export interface InvoiceBalanceSummary {
  total: string;
  credits: string;
  currency: string;
  shipToAddresses: Array<InvoiceAddress>;
}

export interface Invoice {
  invoiceNo: string;
  subtotal: number;
  total: number;
  taxes: number;
  currency: string;
  poNumber?: string;
  status: InvoiceStatus;
  invoiceDate: string;
  dueDate: string;
  shipTo: InvoiceAddress;
  billTo: InvoiceAddress;
  soldTo: InvoiceAddress;
  discounts: InvoiceDiscount[];
  orderDate?: string; // not returned from BE yet
  orderNumber?: string;
  orderLineItems: InvoiceItem[];
  paymentTermsDescription: string;
  notes: string[];
  payment?: InvoicePayment; // not returned from BE yet
}

export interface InvoiceDiscount {
  discountType: DiscountType;
  discountAmount: number;
  discountExpiration: string;
}

export interface InvoicePayment {
  confirmationNumber?: string;
  paymentDate?: string;
  paymentMethod?: string;
  paymentAmount?: string;
  paymentScheduled?: boolean;
  paymentScheduledDate?: string;
}

export interface InvoiceAddress {
  id?: number;
  name?: string;
  line1: string;
  line2?: string;
  city: string;
  state: string;
  postalCode: string;
}

export interface InvoiceItem {
  itemDescription: string;
  contractPrice: number;
  quantity: number;
  subtotal: number;
  ndcNumber: string;
}

export interface InvoiceListData {
  invoices: Invoice[];
  pagination: {
    pageNumber: number;
    pageSize: number;
    total: number;
  };
  filters: {
    status: null;
    shippingLocation: null;
  };
  sorting: {
    sortBy: SortableColumnKeys;
    sortDirection: SortOrder;
  };
}
